import React, { Suspense, lazy } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CursorEffect from './components/CursorEffect';
import CookieConsent from './components/CookieConsent';
import HomePage from './pages/HomePage';
import ResourcePage from './pages/ResourcePage';
import PrintSectorsPage from './pages/PrintSectorsPage';
import TeamPage from './pages/TeamPage';
import IntegrationsPage from './pages/IntegrationsPage';
import AboutPage from './pages/AboutPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ResourcesIndexPage from './pages/ResourcesIndexPage';
import SolutionPage from './pages/SolutionPage';
import NotFoundPage from './pages/NotFoundPage';
import HashScroll from './components/HashScroll';
import AnalyticsTracker from './components/AnalyticsTracker';

// Admin-only pages are code-split so their heavy deps (rich-text editor,
// QR generation) never load for public visitors.
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const PostEditor = lazy(() => import('./pages/PostEditor'));
const AdminEmailSignature = lazy(() => import('./pages/AdminEmailSignature'));
const CRMPage = lazy(() => import('./pages/admin/CRMPage'));
const BusinessCardDesigner = lazy(() => import('./pages/admin/BusinessCardDesigner'));
const AnalyticsPage = lazy(() => import('./pages/admin/AnalyticsPage'));

function App() {
  React.useEffect(() => {
    // Static SEO tags in index.html serve no-JS crawlers (WhatsApp/FB).
    // Once React mounts, Helmet provides per-page tags — drop the static
    // ones so JS-executing crawlers (Google) never see duplicates.
    document.querySelectorAll('head [data-rh="true"]').forEach((el) => el.remove());
  }, []);

  return (
    <div className="app-wrapper">
      <BrowserRouter>
        <CursorEffect />
        <HashScroll />
        <AnalyticsTracker />
        <Navbar />
        <main>
          <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/print-sectors" element={<PrintSectorsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/resources" element={<ResourcesIndexPage />} />
            <Route path="/resources/:slug" element={<ResourcePage />} />
            <Route path="/solutions/:slug" element={<SolutionPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/posts" element={<AdminDashboard />} />
            <Route path="/admin/posts/new" element={<PostEditor />} />
            <Route path="/admin/posts/:id/edit" element={<PostEditor />} />
            <Route path="/admin/email-signature" element={<AdminEmailSignature />} />
            <Route path="/admin/crm" element={<CRMPage />} />
            <Route path="/admin/business-card" element={<BusinessCardDesigner />} />
            <Route path="/admin/analytics" element={<AnalyticsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          </Suspense>
        </main>
        <Footer />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
